import { computed } from 'vue'
import { useApiStore } from '../stores/apiStore.js'

/**
 * Content Composable
 * Bietet Zugriff auf verschiedene Content-Typen (About, Globals, Notices, etc.)
 */
export function useContent() {
  const apiStore = useApiStore()

  return {
    // About
    about: computed(() => apiStore.about),
    aboutLoading: computed(() => apiStore.aboutLoading),
    aboutError: computed(() => apiStore.aboutError),
    hasAbout: computed(() => apiStore.hasAbout),
    loadAbout: () => apiStore.loadAbout(),


    // Notices
    notices: computed(() => apiStore.notices),
    noticesLoading: computed(() => apiStore.noticesLoading),
    noticesError: computed(() => apiStore.noticesError),
    hasNotices: computed(() => apiStore.hasNotices),
    loadNotices: () => apiStore.loadNotices(),

    // Contact
    contact: computed(() => apiStore.contact),
    contactLoading: computed(() => apiStore.contactLoading),
    contactError: computed(() => apiStore.contactError),
    hasContact: computed(() => apiStore.hasContact),
    loadContact: () => apiStore.loadContact(),

    // Generic Content
    content: computed(() => apiStore.content),
    contentLoading: computed(() => apiStore.contentLoading),
    contentError: computed(() => apiStore.contentError),
    hasContent: computed(() => apiStore.hasContent),
    getContentByIdentifier: (identifier) => apiStore.getContentByIdentifier(identifier),
    loadContent: (options) => apiStore.loadContent(options),

    // Background Images
    backgroundImages: computed(() => apiStore.backgroundImages),
    backgroundImagesLoading: computed(() => apiStore.backgroundImagesLoading),
    backgroundImagesError: computed(() => apiStore.backgroundImagesError),
    hasBackgroundImages: computed(() => apiStore.hasBackgroundImages),
    getBackgroundImageByIdentifier: (identifier) => apiStore.getBackgroundImageByIdentifier(identifier),
    loadBackgroundImages: () => apiStore.loadBackgroundImages(),

    // Impressions
    impressions: computed(() => apiStore.impressions),
    impressionsLoading: computed(() => apiStore.impressionsLoading),
    impressionsError: computed(() => apiStore.impressionsError),
    hasImpressions: computed(() => apiStore.hasImpressions),
    loadImpressions: () => apiStore.loadImpressions()
  }
}